module.exports = __webpack_public_path__ + "img/are-you-ready.58d9c5f0.jpg";